module.exports = __webpack_public_path__ + "static/media/slidee-3.3793f773.jpg";